/**
 * Minimal Service Worker Registration for PWA
 *
 * Only registers the service worker to enable PWA installation.
 * Does NOT provide offline functionality or caching.
 * Designed to never block or break the website.
 */

export function registerServiceWorker() {
  // Skip if service workers not supported
  if (!('serviceWorker' in navigator)) {
    console.log('[SW] Service workers not supported');
    return;
  }

  // Register the unified service worker (same file OneSignal uses)
  // CRITICAL: Must be the same file as OneSignal's serviceWorkerPath
  // to prevent two SWs fighting for scope '/' and breaking fetch handling
  navigator.serviceWorker
    .register('/OneSignalSDKWorker.js', { scope: '/' })
    .then((registration) => {
      console.log('[SW] Service worker registered for PWA');
    })
    .catch((error) => {
      // Silent fail - don't break the app
      console.log('[SW] Registration failed (non-critical):', error.message);
    });
}

export function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations()
      .then(registrations => {
        registrations.forEach(reg => reg.unregister());
      })
      .catch(() => {});
  }
}

// Stub for backwards compatibility - does nothing now
export function setupOnlineOfflineListeners(onOnline, onOffline) {
  return () => {}; // Return no-op cleanup function
}

// Stub for backwards compatibility
export function enablePWA() {}
